<template>
  <v-snackbar v-model="isVisible" :timeout="3000" top right>
    {{ this.notification }}
    <v-btn dark flat @click="dismiss">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data: () => ({
    isVisible: false
  }),
  computed: {
    notification () {
      return this.$store.getters.globalNotification
    },
    title () {
      return this.notification ? this.notification.title : ''
    }
  },
  watch: {
    notification (val) {
      if (val) {
        this.isVisible = true
      } else {
        this.isVisible = false
        this.dismiss()
      }
    }
  },
  mounted () {

  },
  methods: {
    dismiss () {
      this.$store.dispatch('clearNotification')
    }
  }
}
</script>
